import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const HomeService = {
  getdata: async () => {
    try {
      const response = await apiService.get("/homesections");
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  create: async (data) => {
    const response = await apiService.post("/homesections", data);
    return response.data;
  },
  bulkUpdateMany: async (updateddata) => {
    const response = await apiService.put(
      `/homesections/bulk-update`,
      updateddata
    );
    return response.data;
  },
  getdetails: async (slug) => {
    const response = await apiService.get("/homesections/slug", {
      params: { slug: slug },
    });

    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/homesections/${id}`);
    return response.data;
  },
  getDashboarddata: async () => {
    try {
      const response = await apiService.get("/dashboard/dashboard-count");
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default HomeService;
